import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllMenuCategories = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .fetchAllMenuCategories(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_MENU_CATEGORIES_FAILED,
              reject: actionTypes.FETCH_ALL_MENU_CATEGORIES_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_MENU_CATEGORIES_LOADING);
  const success = res =>
    action(actionTypes.FETCH_ALL_MENU_CATEGORIES_SUCCESS, res);

  return request();
};

export const changeMenuCategoryActivity = (id, isActive) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .changeMenuCategoryActivity(id, isActive)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHANGE_MENU_CATEGORY_STATUS_FAILED,
              reject: actionTypes.CHANGE_MENU_CATEGORY_STATUS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHANGE_MENU_CATEGORY_STATUS_LOADING);
  const success = res =>
    action(actionTypes.CHANGE_MENU_CATEGORY_STATUS_SUCCESS, res);

  return request();
};

export const fetchAllDeletedMenuCategories = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .fetchAllDeletedMenuCategories(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_FAILED,
              reject: actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_LOADING);
  const success = res =>
    action(actionTypes.FETCH_ALL_DELETED_MENU_CATEGORIES_SUCCESS, res);

  return request();
};

export const deleteMenuCategory = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .deleteMenuCategory(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_MENU_CATEGORY_FAILED,
              reject: actionTypes.DELETE_MENU_CATEGORY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_MENU_CATEGORY_LOADING);
  const success = res => action(actionTypes.DELETE_MENU_CATEGORY_SUCCESS, res);

  return request();
};

export const fetchMenuCategoryById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .fetchMenuCategoryById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_MENU_CATEGORY_BY_ID_FAILED,
              reject: actionTypes.FETCH_MENU_CATEGORY_BY_ID_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_MENU_CATEGORY_BY_ID_LOADING);
  const success = res =>
    action(actionTypes.FETCH_MENU_CATEGORY_BY_ID_SUCCESS, res);

  return request();
};

export const insertNewMenuCategory = categoryObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .insertNewMenuCategory(categoryObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_MENU_CATEGORY_FAILED,
              reject: actionTypes.INSERT_NEW_MENU_CATEGORY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_MENU_CATEGORY_LOADING);
  const success = res =>
    action(actionTypes.INSERT_NEW_MENU_CATEGORY_SUCCESS, res);

  return request();
};

export const updateMenuCategory = categoryObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .updateMenuCategory(categoryObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.EDIT_MENU_CATEGORY_FAILED,
              reject: actionTypes.EDIT_MENU_CATEGORY_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.EDIT_MENU_CATEGORY_LOADING);
  const success = res => action(actionTypes.EDIT_MENU_CATEGORY_SUCCESS, res);

  return request();
};

export const fetchPrinters = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.menuCategories
        .fetchPrinter()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_PRINTERS_FAILED,
              reject: actionTypes.FETCH_PRINTERS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_PRINTERS_LOADING);
  const success = res => action(actionTypes.FETCH_PRINTERS_SUCCESS, res);

  return request();
};
